import React from "react";
import ReferFriend from "../img/refer-friend.svg";
import BackButton from "../img/icons/icon_blue_back.svg";
import WhtspIcon from "../img/icons/icon_wa.svg";
import EmailIcon from "../img/icons/icon_mail.svg";
import InstaIcon from "../img/icons/icon_instagram.svg";
import FBIcon from "../img/icons/icon_fb.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ReferToFriendPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/home" className="icon_left" id="menu_hamburger">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title"></span>
          </Link>
        </div>
      </header>
      <div className="body_content">
        <div className="inner_body ">
          <div className="refer_block text-center">
            <h3 className="refer_title">{t("sidenav.FRIEND.message1")}</h3>
            <div className="thumb mt-3">
              <img src={ReferFriend} alt="" className="img-fluid" />
            </div>
            <div className="btn_block d-flex align-items-center justify-content-center">
              <button
                className="w-50 mt-5 btn btn_primary"
                data-bs-toggle="modal"
                data-bs-target="#modal_invite_friends"
              >
                {t("sidenav.FRIEND.message2")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        id="modal_invite_friends"
        className="modal custom_modal_invite custom_modal modal fade"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb_invite pb-4">
                <h3 className="subtitle_invite">
                  {t("sidenav.FRIEND.message3")}{" "}
                </h3>
                <p className="txt_desc">{t("sidenav.FRIEND.message4")}</p>
                <ul className="list-unstyled list_socialshare ">
                  <li>
                    <Link to="#" target="_blank">
                      <img src={WhtspIcon} alt="" className="img-fluid " />
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <img src={EmailIcon} alt="" className="img-fluid mt-2" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <img src={InstaIcon} alt="" className="img-fluid" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <img src={FBIcon} alt="" className="img-fluid" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- END FOR MODAL INVITE FRIENDS --> */}
    </>
  );
};

export default ReferToFriendPage;
